// extracted by mini-css-extract-plugin
export default {"selection":"Selection_selection__8GRFV","selectionActive":"Selection_selectionActive__p41xP"};